import { render, staticRenderFns } from "./RecorderOverlay.vue?vue&type=template&id=aa388ba8&scoped=true"
import script from "./RecorderOverlay.vue?vue&type=script&lang=js"
export * from "./RecorderOverlay.vue?vue&type=script&lang=js"
import style0 from "./RecorderOverlay.vue?vue&type=style&index=0&id=aa388ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa388ba8",
  null
  
)

export default component.exports